import { useParams } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { ReconciliationMatchView } from '@webapp/modules/accounts-payable/feature-sets/ReconciliationMatchView'
import { useCreditCardStatementDetailsPresenter } from '@webapp/modules/accounts-payable/features/get-credit-card-account/presenters/CreditCardStatementDetailsPresenter'
import messages from './messages'
import {
  AccountDetailsPageTabs,
  type ReconciliationMatchPageParams,
} from './types'

export const ReconciliationMatchPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()
  const { id, tab } = useParams<ReconciliationMatchPageParams>()

  const accountId = Number(id)

  // Presenter companion hook (hook-data only) supplies the account-name
  // crumb; React Query dedupes with the Feature Set's calls (Sibling Pages
  // pattern).
  const { account } = useCreditCardStatementDetailsPresenter({ accountId })

  return (
    <Page
      pageTitle={intl.formatMessage(messages.reconciliationMatchPageTitle)}
      breadcrumbs={[
        {
          link: url('CreditCardReconciliationPage'),
          name: intl.formatMessage(messages.creditCardReconciliationPageTitle),
        },
        ...(account
          ? [
              {
                link: url('CreditCardAccountDetailsPage', {
                  id: String(accountId),
                  tab: AccountDetailsPageTabs.ACTIVE,
                }),
                name: account.name,
              },
            ]
          : []),
        {
          name: intl.formatMessage(messages.reconciliationMatchPageTitle),
        },
      ]}
    >
      <ReconciliationMatchView accountId={accountId} tab={tab} />
    </Page>
  )
}
